export const tableMarkup = {
  methods: {
    tableMarkup(thead, tbody) {
      let theadContent = ''
      let tbodyContent = ''
      thead.forEach((el) => {
        theadContent += `<th class="w-1/2 py-3 px-4 text-center uppercase text-sm">${this.$i18n.t(
          el
        )}</th>`
      })
      tbody.forEach((el, index) => {
        tbodyContent += `<tr class='hover:bg-blue-100 hover:bg-opacity-20'><td class='w-0 py-3 px-4'>${
          index + 1
        }</td>`
        Object.entries(el).forEach((entry) => {
          const [key, value] = entry
          tbodyContent += `<td class="w-1/2 whitespace-nowrap py-3 px-4 text-center">${value}</td>`
        })
        tbodyContent += '</tr>'
      })
      return `            
          <div class="shadow overflow-auto rounded my-4 table-wrp block ">
              <table class="min-w-full bg-white">
                  <thead class="bg-gray-800 sticky top-0 text-white border-b border-gray-200">
                  <tr>
                      <th class="w-0 py-3 px-4 uppercase text-sm">${this.$i18n.t(
                        'INDEX'
                      )}</th>
                      ${theadContent}
                  </tr>
                  </thead>
                  <tbody class="text-gray-700 divide-y divide-y divide-gray-200">                        
                      ${tbodyContent}
                  </tbody>
              </table>
          </div>
        `
    },
  },
}
